import React from 'react';
export var RadioContext = React.createContext(null);
export var useRadio = function () { return React.useContext(RadioContext); };
